// extracted by mini-css-extract-plugin
export default {"form":"Y24IXZ31","mobile":"mobile","row":"j8TAlyoL","field":"if6nLq2O","footer":"tMn8bYQu","errorMessage":"EMGiBZ21"};